export enum YesNoOptionType {
  Yes = 'yes',
  No = 'no'
}
